import { configureStore, combineReducers } from "@reduxjs/toolkit";
import toolsReducer from "./features/toolsSlice";
import loginRegisterReducer from "./features/loginRegisterSlice";
import commonApiContentReducer from "./features/commonApiDataSlice";
import offersReducer from "./features/offersSlice";
import myPolicyReducer from "./features/myPolicySlice";
import newPoliciesStaticDataReducer from "./features/newPolicySlice";
import newMotorFormReducer from "./features/newMotorFormSlice";
import newTravelFormReducer from "./features/newTravelFormSlice";
import profileReducer from "./features/profileSlice";
import motorInsuranceReducer from "./features/motorInsuranceFlowSlice";
import travelInsuranceReducer from "./features/travelInsuranceFlowSlice";
import carsListReducer from "./features/constants/carsListSlice";
import motorInsuranceRenewReducer from "./features/motorInsuranceRenewFlowSlice";
import banksListReducer from "./features/constants/banksListSlice";
import countriesListReducer from "./features/constants/countriesListSlice";
import occupationsListReducer from "./features/constants/occupationsListSlice";
import blocksAndAreasListReducer from "./features/constants/blocksAndAreasListSlice";
import nationalitiesReducer from "./features/constants/nationalitiesSlice";
import getSumInsuredReducer from "./features/motor/getSumInsuredSlice";
import calculatePremiumReducer from './features/motor/calculatePremiumSlice';
import getQuoteReducer from './features/motor/getQuoteSlice';
import motorInsuranceAddMoreCoversFlowReducer from "./features/motorInsuranceAddMoreCoversFlowSlice";
import motorInsuranceAdjustSumInsuredFlowReducer from "./features/motorInsuranceAdjustSumInsuredFlowSlice";
import motorInsuranceChangePlanFlowReducer from "./features/motorInsuranceChangePlanFlowSlice";
import motorInsuranceFileClaimFlowReducer from "./features/motorInsuranceFileClaimFlowSlice";
import policyPremiumReducer from "./features/motor/renewalPremiumSlice";
import getFilesReducer from "./features/upload/fileUploadSlice";
import gdtReducer from "./features/motor/gdtSlice";
import scannerReducer from "./features/ai/scannerSlice";
import accountOtpReducer from "./features/account/accountOtpSlice";
import updateMobileApiReducer from "./features/account/updateMobileApiSlice";
import notificationsReducer from "./features/notificationsSlice";
import otpReducer from "./features/sendOtpSlice";
import verifyOtpReducer from './features/verifyOtpSlice';
import expressShieldReducer from "./features/expressShieldFlowSlice";
import expressShieldFlowStrapiCmsReducer from "./features/buyOnlinePlans/expressShieldFlowStrapiCmsSlice";
import essentialCareFlowStrapiCmsReducer from "./features/essentialCare/essentialCareStrapiCmsSlice";
import { resetRedux } from "./features/resetSlice";
import policyDetailsReducer from "./features/policyDetailsSlice";
import signupReducer from "./features/signUp/signUpSlice";
import createCustomerAccountReducer from "./features/signUp/signUpSlice";
import verifySessionReducer from "./features/signUp/createVeriffSessionSlice";
import addressVerificationReducer from "./features/signUp/addressVerificationSlice";
import viewDocsReducer from "./features/motor/policyDocsViewSlice"
import cancellationReducer from "./features/endorsements/cancellationSlice"
import policyPayReducer from "./features/payment/policyPaySlice"
import ScanBankLetterReducer from "./features/motor/scanBankLetterSlice"
import RemoveBankNameReducer from "./features/motor/RemoveBankSlice"


import fundsSwitchingFlowReducer from "./features/fundsSwitchingFlowSlice";
import ExpressLeadReducer from "./features/expressSheild/leadSlice";
import newLifeFormReducer from "./features/newLifeFormSlice";
import expressSheildReducer from "./features/expressSheild/expressSheildSlice";
import motorInsurancePolicyCancellationFlowReducer from "./features/motorInsurancePolicyCancellationFlowSlice"
import kycVerificationReducer from "./features/signUp/kycVerificationStatusSlice"
import transferPolicyReducer from "./features/endorsements/transferPolicySlice"
import forgotPasswordReducer from "./features/forgotPasswordFlow/forgotPasswordSlice"
import resetPasswordReducer from "./features/forgotPasswordFlow/resetPasswordSlice"
import allFundsReducer from "./features/allfunds/allFundsSlice";
import lifePolicyDetailReducer from "./features/life/lifePolicyDetailSlice";
import changeMobileNumberFlowReducer from "./features/changeMobileNumberSlice";
import faqsReducer from "./features/faqsSlice";
import crmCaseComplaintReducer from "./features/crm/caseComplaintSlice";
import crmClaimReducer from "./features/crm/crmClaimSlice";
import promoCodeReducer from "./features/promoCode/promoCodeSlice";
  import essentialCareFlowReducer from "./features/essentialCare/essentialCareFlowSlice";
  import essentialCareQuoteReducer from "./features/essentialCare/essentialCareQuoteSlice";
  import ChangePlateNoReducer from "./features/motor/ChangePlateNumberSlice";
import domesticHelperFlowReducer from "./features/domesticHelperFlowSlice";
import domesticHelperFormReducer from "./features/domesticHelperFormSlice";
import homeFlowReducer from "./features/homeFlowSlice";
import homeFormReducer from "./features/homeFormSlice";
import personalAccidentFlowReducer from "./features/personalAccidentFlowSlice";
import personalAccidentFormReducer from "./features/personalAccidentFormSlice";
import personalCyberFlowReducer from "./features/personalCyberFlowSlice";
import personalCyberFormReducer from "./features/personalCyberFormSlice";
import smartDeviceFlowReducer from "./features/smartDeviceFlowSlice";
import smartDeviceFormReducer from "./features/smartDeviceFormSlice";
import travelInsuranceChangePlanFlowReducer from "./features/travelInsuranceChangePlanFlowSlice";
import quoteReducer from "./features/quoteSlice";
import amanFlowReducer from "./features/amanFlowSlice";
import amanFormReducer from "./features/amanFormSlice";
import trackClaimFlowReducer from "./features/trackClaimFlowSlice";
import genericRenewalFlowReducer from "./features/genericRenewalFlowSlice";
import travelRenewalFlowReducer from "./features/travelRenewalFlowSlice";
import bniTravelInsuranceReducer from "./features/bniTravelInsuranceFlowSlice";
import newTravelPolicyFormReducer from "./features/newTravelPolicyFormSlice";

const appReducer = combineReducers({
  notifications: notificationsReducer,
  tools: toolsReducer,
  login_register: loginRegisterReducer,
  common_api_content: commonApiContentReducer,
  offers: offersReducer,
  myPolicies: myPolicyReducer,
  newPoliciesStaticData: newPoliciesStaticDataReducer,
  fundsSwitchingFlow: fundsSwitchingFlowReducer,
  newMotorFormData: newMotorFormReducer,
  newTravelFormData: newTravelFormReducer,
  profile: profileReducer,
  motorInsuranceRenewFlow: motorInsuranceRenewReducer,
  motorInsuranceAddMoreCoversFlow: motorInsuranceAddMoreCoversFlowReducer,
  motorInsuranceAdjustSumInsuredFlow: motorInsuranceAdjustSumInsuredFlowReducer,
  motorInsuranceChangePlanFlow: motorInsuranceChangePlanFlowReducer,
  // Motor Reducers
  motorInsuranceFlow: motorInsuranceReducer,
  // Travel Reducers
  travelInsuranceFlow: travelInsuranceReducer,
  travelInsuranceChangePlanFlow: travelInsuranceChangePlanFlowReducer,
  // BNI Travel Reducers
  bniTravelInsuranceFlow: bniTravelInsuranceReducer,
  newTravelPolicyFormData: newTravelPolicyFormReducer,
  // Domestic Helper Reducers
  domesticHelperFlow: domesticHelperFlowReducer,
  domesticHelperForm: domesticHelperFormReducer,
  homeFlow: homeFlowReducer,
  homeForm: homeFormReducer,
  // Personal Accident Reducers
  personalAccidentFlow: personalAccidentFlowReducer,
  personalAccidentFormData: personalAccidentFormReducer,
  // Personal Cyber Reducers
  personalCyberFlow: personalCyberFlowReducer,
  personalCyberFormData: personalCyberFormReducer,
  // Smart Device Reducers
  smartDeviceFlow: smartDeviceFlowReducer,
  smartDeviceFormData: smartDeviceFormReducer,
  // Aman Reducers
  amanFlow: amanFlowReducer,
  amanFormData: amanFormReducer,
  // Quote API Management
  quote: quoteReducer,
  carsList: carsListReducer,
  banksList: banksListReducer,
  countriesList: countriesListReducer,
  occupationsList: occupationsListReducer,
  blocksAndAreasList: blocksAndAreasListReducer,
  nationalities: nationalitiesReducer,
  getSumInsured: getSumInsuredReducer,
  calculatePremium: calculatePremiumReducer,
  getQuote: getQuoteReducer,
  policyPremium: policyPremiumReducer,
  // GDT
  gdtApi: gdtReducer,
  // FilesAPI Reducers
  filesAPI: getFilesReducer,
  // Open AI
  scanOS: scannerReducer,
  motorInsuranceFileClaimFlow: motorInsuranceFileClaimFlowReducer,
  // Account OTP
  accountOtp: accountOtpReducer,
  updateMobileApi: updateMobileApiReducer,
  otpData: otpReducer,
  verifyOtpData: verifyOtpReducer,
  expressShieldFlow: expressShieldReducer,
  expressShieldFlowStrapiCms: expressShieldFlowStrapiCmsReducer,
  essentialCareFlow: essentialCareFlowReducer,
  essentialCareFlowStrapiCms: essentialCareFlowStrapiCmsReducer,
  signup: signupReducer,
  createCustomerAccount: createCustomerAccountReducer,
  verifySession: verifySessionReducer,
  addressVerification: addressVerificationReducer,
  changeMobileNumberFlow: changeMobileNumberFlowReducer,
  // Policy
  policyDetails: policyDetailsReducer,
  policyPay: policyPayReducer,
  // Endorsement
  cancellationApi: cancellationReducer,
  viewDocs: viewDocsReducer,
  ScanBankLetter: ScanBankLetterReducer,
  RemoveBankName: RemoveBankNameReducer,
  // Express Sheild
  expressLead: ExpressLeadReducer,
  expressSheild: expressSheildReducer,
  newLifeFormData: newLifeFormReducer,
  motorInsurancePolicyCancellationFlow:
    motorInsurancePolicyCancellationFlowReducer,
  kycVerification: kycVerificationReducer,
  transferPolicy: transferPolicyReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  allFunds: allFundsReducer,
  // life policy
  lifePolicyDetail: lifePolicyDetailReducer,
  faqs: faqsReducer,
  // CRM
  crmCaseComplaint: crmCaseComplaintReducer,
  crmClaim: crmClaimReducer,
  // Promo Code
  promoCode: promoCodeReducer,
  essentialCare : essentialCareQuoteReducer,
  ChangePlateNo: ChangePlateNoReducer,
  trackClaimFlow: trackClaimFlowReducer,
  genericRenewalFlow: genericRenewalFlowReducer,
  travelRenewalFlow: travelRenewalFlowReducer,
});

// Root reducer to handle reset action
const rootReducer = (state, action) => {
  if (action.type ==resetRedux.type) {
    // some of cms content should not be reset
    const { login_register, tools, common_api_content } = state;
    state = { login_register, tools, common_api_content };
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

// TODO: refresh also persist the values if needed
